export default "__VITE_ASSET__BKwiNnFE__"